// import { useTheme } from '@emotion/react';
const defaultWidth = 24;
const defaultHeight = 24;

export const DesktopIcon = ({ width = defaultWidth, height = defaultHeight, color = '#24292E' }: SvgProps) => {
  // const {
  //   colors: { Gray },
  // } = useTheme();

  return (
    <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform={`scale(${width / defaultWidth}, ${height / defaultHeight})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.95352 17H2.75C1.7835 17 1 16.2165 1 15.25V3.75C1 2.7835 1.7835 2 2.75 2H21.25C22.2165 2 23 2.7835 23 3.75V15.25C23 16.2165 22.2165 17 21.25 17H15.0463C15.217 18.3751 15.8509 19.6522 16.815 20.7568C17.0083 20.9784 17.0544 21.2926 16.9327 21.5604C16.811 21.8281 16.544 22 16.2499 22H7.74989C7.45578 22 7.18882 21.8281 7.06711 21.5604C6.94541 21.2926 6.99144 20.9784 7.18482 20.7568C8.14891 19.6522 8.78282 18.3751 8.95352 17ZM21.5 3.75V15.25C21.5 15.3881 21.3881 15.5 21.25 15.5H2.75C2.61193 15.5 2.5 15.3881 2.5 15.25V3.75C2.5 3.61193 2.61193 3.5 2.75 3.5H21.25C21.3881 3.5 21.5 3.61193 21.5 3.75ZM13.5369 17C13.6624 18.2662 14.1009 19.445 14.7601 20.5H9.23971C9.89885 19.445 10.3373 18.2662 10.4629 17H13.5369Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2998 15.2498V3.7498C21.2998 3.72219 21.2774 3.6998 21.2498 3.6998H2.7498C2.72219 3.6998 2.6998 3.72219 2.6998 3.7498V15.2498C2.6998 15.2774 2.72219 15.2998 2.7498 15.2998H21.2498C21.2774 15.2998 21.2998 15.2774 21.2998 15.2498ZM8.72257 17.1998H2.7498C1.67285 17.1998 0.799805 16.3268 0.799805 15.2498V3.7498C0.799805 2.67285 1.67285 1.7998 2.7498 1.7998H21.2498C22.3268 1.7998 23.1998 2.67285 23.1998 3.7498V15.2498C23.1998 16.3268 22.3268 17.1998 21.2498 17.1998H15.2768C15.4799 18.4439 16.0762 19.6062 16.9654 20.6251C17.2104 20.9058 17.2687 21.3038 17.1145 21.6429C16.9604 21.9821 16.6222 22.1998 16.2497 22.1998H7.74969C7.37716 22.1998 7.039 21.9821 6.88485 21.6429C6.73069 21.3038 6.78899 20.9058 7.03394 20.6251C7.92321 19.6062 8.51944 18.4439 8.72257 17.1998ZM13.3577 17.1998H10.6417C10.5054 18.3106 10.1349 19.3519 9.59224 20.2998H14.4072C13.8645 19.3519 13.494 18.3106 13.3577 17.1998Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

DesktopIcon.displayName = 'DesktopIcon';
